<template>
    <div class="c-clock">
        {{time}}
    </div>
</template>

<script>
import {formatTime, formatDate} from "@/utils/utils";

export default {
    name:"Clock",
    data() {
        return {
            time: ""
        };
    },
    created() {
        setInterval(() => {
            this.updateTime();
                
        }, 1000);
        this.updateTime();
    },
    methods: {
        updateTime() {
            const now = new Date();

            this.time = formatTime(now) + " - " + formatDate(now);
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-clock {
        margin: auto;
        width: 25vw;
        padding-top: .7rem;
        text-align: center;
        font-size: 1.3em;
        overflow: hidden;
        white-space: nowrap;
    }
</style>